<app-simple-modal-header
	[pageTitle]="pageTitle"
	(dismissed)="dismiss()"
></app-simple-modal-header>

<ion-content>
	<form [formGroup]="form">
		<ion-list lines="full" *ngIf="isLoaded">
			<ion-item>
				<ion-label position="stacked">
					Charge Code
				</ion-label>
				<ion-select
					placeholder="Select"
					[interfaceOptions]="{ header: 'Charge Code' }"
					[compareWith]="compareWith"
					[value]="chargeCodeControl.value"
					[formControl]="chargeCodeControl"
					class="text-wrap"
				>
					<ion-select-option
						*ngFor="let charge of additionalCharges; index as index"
						[value]="charge"
					>
						{{ charge.desc }}
					</ion-select-option>
				</ion-select>
			</ion-item>
			<ion-item>
				<ion-label position="stacked">
					Quantity
				</ion-label>
				<ion-input
					type="number"
					min="1"
					max="999"
					value="1"
					[formControl]="quantityControl"
				></ion-input>
			</ion-item>
			<ion-item>
				<ion-label position="stacked">
					Billable
				</ion-label>
				<ion-select
					placeholder="Select"
					[formControl]="billableControl"
				>
					<ion-select-option
						*ngFor="let isBillable of billableOptions"
						[value]="isBillable === 'Yes' ? true : false"
					>
						{{ isBillable }}
					</ion-select-option>
				</ion-select>
			</ion-item>
		</ion-list>
	</form>
</ion-content>

<ion-footer>
	<ion-button
		expand="full"
		type="submit"
		class="modal__submit"
		(click)="onClickAddCharge()"
	>
		Add Charge
	</ion-button>
</ion-footer>
